<template>
    <div class="w-full lg:w-auto flex flex-col lg:flex-row font-bold h-full divide-y lg:divide-y-0">
        <slot />
    </div>
</template>
